// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"235":"UIUX","443":"about"}[chunkId] + "." + {"235":"b0574d00","443":"43f19bf9"}[chunkId] + ".css";
};